<template>
    <form @submit="validateForm" action="/carparks" method="get" class="space-y-6">
        <AlertView :errors="errors" />
        <SelectInput label="Airport" name="airport" disabled="true" :options="['Edinburgh']"></SelectInput>
        <DateTimeInput v-model="entryTimestamp" label="Arrive at carpark:" name="entryTimestamp" :attributes="attributes" />
        <DateTimeInput v-model="exitTimestamp" label="Return to carpark:" name="exitTimestamp" :attributes="attributes" />
        <AppButton type="submit">Check Prices</AppButton>
    </form>
</template>

<script>
import moment from 'moment';
import DateTimeInput from '../globals/DateTimeInput.vue';

export default {
    components: {
        DateTimeInput,
    },
    data() {
        return {
            entryTimestamp: null,
            exitTimestamp: null,
            errors: [],
        };
    },
    methods: {
        validateForm(e) {
            this.errors = [];

            if (!this.entryDateIsBeforeExit()) {
                this.errors.push('Entry date cannot be after exit');
                e.preventDefault();
                return;
            }

            if (!this.entryIsMoreThanOneHourAway()) {
                this.errors.push('Entry must be more than 1 hour away');
                e.preventDefault();
                return;
            }

            if (!this.exitIsAtLeastTwoHoursAfterEntry()) {
                this.errors.push('Minimum stay at the carpark is two hours');
                e.preventDefault();
            }
        },
        entryDateIsBeforeExit() {
            const entryDate = moment(this.entryTimestamp);
            const exitDate = moment(this.exitTimestamp);

            return entryDate.isBefore(exitDate);
        },
        entryIsMoreThanOneHourAway() {
            const entryDate = moment(this.entryTimestamp);
            const timeInOneHour = (new Date()).setHours((new Date()).getHours() + 1);

            return entryDate.isAfter(timeInOneHour);
        },
        exitIsAtLeastTwoHoursAfterEntry() {
            const entryDate = moment(this.entryTimestamp);
            const exitDate = moment(this.exitTimestamp);
            const twoHoursAfterStay = entryDate.add(2, 'hours');

            return exitDate.isSameOrAfter(twoHoursAfterStay, 'minute');
        },
    },
    computed: {
        attributes() {
            const dates = {
                start: this.entryTimestamp,
                end: this.exitTimestamp,
            };

            return [{
                highlight: true,
                dates,
            }];
        },
    },
    watch: {
        entryTimestamp(value) {
            const exitTimestamp = moment(this.exitTimestamp);
            const entryTimestamp = moment(value);

            if (exitTimestamp.isBefore(entryTimestamp)) {
                this.exitTimestamp = this.dateToTimestamp(entryTimestamp);
            }
        },
    },
    created() {
        this.entryTimestamp = this.dateToTimestamp(new Date(new Date().getTime() + 86400000));
        this.exitTimestamp = this.dateToTimestamp(new Date(new Date().getTime() + 172800000));
    },
};
</script>
